import { message } from 'antd';
import { queryAnnouncementInfo } from '@api/administrative/announcement';
import PageAdd from './PageAdd';

class PageEdit extends PageAdd {
  componentDidMount() {
    this.getAnnouncement();
  }

  getAnnouncement = () => {
    queryAnnouncementInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default PageEdit;



// WEBPACK FOOTER //
// ./src/components/administrative/announcement/PageEdit.js